import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../models/common/IGenericPayload";
import { emptyStatisticsFilter, IStatisticsFilter } from "../../../../models/statistics/IStatisticsFilters";

interface IStatiticsInspectionFilterState {
    filter: IStatisticsFilter;
}

const initialState: IStatiticsInspectionFilterState = {
    filter: emptyStatisticsFilter(),
};

export const statisticsInspectionFilterSlice = createSlice({
    name: "statisticsInspectionFilterSlice",
    initialState,
    reducers: {
        resetStatisticsInspectionFilter: () => initialState,
        updateFilterProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.filter = {
                ...state.filter,
                [action.payload.name]: action.payload.value,
            };
        },
    },
});

export const { resetStatisticsInspectionFilter, updateFilterProperty } = statisticsInspectionFilterSlice.actions;

export default statisticsInspectionFilterSlice.reducer;
